// Como as telas descrevem a margem a partir da regra vigente da unidade.
//
// As telas supunham "salario liquido x 35%": errado para todo orgao com regra
// propria e, em `margem_da_folha` (Caucaia), para a propria coluna do salario —
// ali ela ja' e' a margem de emprestimo que a folha mandou.

import type { RegraMargemDaTela } from "@atlas/sdk";

/** "30%", "5%", "12,5%". */
export function pctDaRegra(fracao: number): string {
  return `${(Math.round(fracao * 1000) / 10).toLocaleString("pt-BR")}%`;
}

/** O rotulo da coluna `salarioLiquido`: a margem, quando e' ela que vem ali. */
export function rotuloDaColunaSalario(regra: RegraMargemDaTela | undefined, rotulo: string): string {
  return regra?.base === "margem_da_folha" ? "Margem informada (folha)" : rotulo;
}
